import { render } from "./CommentPopover.vue?vue&type=template&id=e44f2e70"
import script from "./CommentPopover.vue?vue&type=script&lang=js"
export * from "./CommentPopover.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommentPopover.vue?vue&type=style&index=0&id=e44f2e70&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__